// Order journey stages — shared between the customer tracking page
// and the admin dashboard so the two can never drift apart.
//
// `key` is what gets stored in the `stage` field.
// Order of this array defines the progression.

export const ORDER_STAGES = [
  {
    key: "sourcing",
    label: "Sourcing the Gemstone",
    description: "We're hand-selecting the perfect certified stone for your piece.",
    icon: "💎",
  },
  {
    key: "crafting",
    label: "In the Craftsman's Hands",
    description: "Your piece is being handcrafted by our artisan.",
    icon: "🔨",
  },
  {
    key: "certification",
    label: "Certification in Progress",
    description: "The gemstone is being verified and its report prepared.",
    icon: "📜",
    // Only shown when the customer ordered a certificate.
    requiresCertificate: true,
  },
  {
    key: "ready",
    label: "Ready to Deliver",
    description: "Finished, quality-checked and packed, ready to be dispatched.",
    icon: "🎁",
  },
  {
    key: "shipped",
    label: "Handed Over to Courier",
    description: "On its way to you with Pronto. Live courier updates below.",
    icon: "🚚",
  },
];

// Stages that actually apply to a given order. Customers who didn't order a
// certificate never see the certification step, so their timeline doesn't
// appear stuck on a stage that will never happen.
export const getStagesForOrder = (hasCertificate) =>
  ORDER_STAGES.filter((s) => !s.requiresCertificate || hasCertificate);

// Index within the stages that apply to this order (not the full list).
export const getStageIndex = (stageKey, hasCertificate = true) =>
  getStagesForOrder(hasCertificate).findIndex((s) => s.key === stageKey);